var React = require('react');

function CtaArrowMobileRed (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M19.0563 3.0147C19.0563 2.73855 18.8325 2.5147 18.5563 2.5147L14.0563 2.5147C13.7802 2.5147 13.5563 2.73855 13.5563 3.0147C13.5563 3.29084 13.7802 3.5147 14.0563 3.5147L18.0563 3.5147L18.0563 7.5147C18.0563 7.79084 18.2802 8.0147 18.5563 8.0147C18.8325 8.0147 19.0563 7.79084 19.0563 7.5147L19.0563 3.0147ZM3.35355 18.9246L18.9099 3.36825L18.2028 2.66114L2.64645 18.2175L3.35355 18.9246Z","fill":"#e3232a"}));
}

CtaArrowMobileRed.defaultProps = {"width":"22","height":"22","viewBox":"0 0 22 22","fill":"none"};

module.exports = CtaArrowMobileRed;

CtaArrowMobileRed.default = CtaArrowMobileRed;
